import isArrayNotEmpty from '@/tools/isarraynotempty';

const getAcademicYear = (schedule: any): string => {
  if (!isArrayNotEmpty(schedule)) return '';
  const [data] = schedule;
  const { academic_year } = data;
  return typeof academic_year === 'string' && academic_year.length
    ? `${academic_year.split('-').join(' — ')} учебный год`
    : '';
};

export default getAcademicYear;



// WEBPACK FOOTER //
// ./src/services/subgroups/utils/getAcademicYear.ts